<template>
  <main id="clientBox" v-if="isAuthed">
    <ClientFiler v-if="getRootMediaId"
      :cid="getClientId"
      :rid="getRootMediaId"
    />
  </main>
</template>

<script>
import ClientFiler from '@/components/filers/client'
// import ClientFiler from '@/components/media/client'
export default {
  name: 'clientBox',
  components: {
    ClientFiler
  },
  data () {
    return {
      config: {
        status: {
          authed: false
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
    },
    auth: function () {
      const roles = this.$store.getters['author/get']('authority') || []
      const permit = this.$route.meta.permit || ''
      if (!roles.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    },
    getRootMediaId () {
      return this.$store.getters['client/get']('lib').media
    },
    getClientId () {
      return this.$route.params.id
    }
  }
}
</script>